module.exports = __webpack_public_path__ + "static/media/logo_pink.09adfa04.svg";